
export class Material {
  constructor(
    public sprite: string | null = null,
    public color: string = 'rgba(255, 255, 255, 1.0)'
  ) {}
}
